<template>
  <NewManifest
    :show="show"
    :loading-manufacturer-results="loadingManufacturerResults"
    :loading-carrier-results="loadingCarrierResults"
    :carriers="carriers"
    :images="images"
    :manufacturers="manufacturers"
    :status-options="statusOptions"
    :departure-date="departureDate"
    :arrival-date="arrivalDate"
    @update:show="cancel"
    @addManifest="addNewManifest"
    @uploadDocument="upload"
    @deleteImage="deleteImage"
    @searchManufacturers="executeSearchManufacturers"
    @searchCarriers="executeSearchCarriers" />
</template>
<script>
import { mapActions } from 'vuex';
import NewManifest from './_components/NewManifest.vue';

export default {
  name: 'NewManifestModule',
  components: { NewManifest },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    departureDate: {
      type: Date,
      required: true,
    },
    arrivalDate: {
      type: Date,
      required: true,
    },
  },
  async created() {
    this.manufacturers = await this.searchManufacturers('');
    this.carriers = await this.searchCarriers('');
  },
  data() {
    return {
      uploadedDocuments: [],
      manufacturers: [],
      carriers: [],
      images: [],
      statusOptions: ['open', 'in_progress', 'closed'],
      loadingManufacturerResults: false,
      loadingCarrierResults: false,
    };
  },
  methods: {
    ...mapActions('$_manifest', [
      'addManifest',
      'uploadDocument',
      'associateDocumentsWithManifest',
      'deleteDocuments',
    ]),
    ...mapActions('manufacturer', [
      'searchManufacturers',
    ]),
    ...mapActions('carrier', [
      'searchCarriers',
    ]),
    deleteImage(id) {
      this.images = this.images.filter(image => image.id !== id);
      this.deleteDocuments([id]);
    },
    getImageFromBufferData(data) {
      const byteArray = new Uint8Array(data.buffer.data);
      const blob = new Blob([byteArray], { type: data.contentType });
      return {
        id: data.id,
        description: data.name,
        src: URL.createObjectURL(blob),
      };
    },
    async upload(data) {
      const document = await this.uploadDocument({ file: data.file });
      this.uploadedDocuments.push(document.id);
      const imageData = this.getImageFromBufferData(document);
      this.images.push(imageData);
    },
    async cancel() {
      // delete these documents because they are now orphans
      this.deleteDocuments(this.uploadedDocuments);
      this.$emit('update:show', false);
    },
    async addNewManifest(data) {
      const newManifest = await this.addManifest(data);
      this.associateDocumentsWithManifest({
        id: newManifest.id,
        documents: this.uploadedDocuments,
      });
      this.uploadedDocuments = [];
      this.$emit('update:show', false);
    },
    async executeSearchManufacturers(search) {
      this.loadingManufacturerResults = true;
      this.manufacturers = await this.searchManufacturers(search);
      this.loadingManufacturerResults = false;
    },
    async executeSearchCarriers(search) {
      this.loadingCarrierResults = true;
      this.carriers = await this.searchCarriers(search);
      this.loadingCarrierResults = false;
    },
  },
};
</script>
